import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const OPEN_OS_DETAILS_KEY = 'painelos:openOsDetails';

/** Abre os detalhes de uma OS no board quando outra tela pediu (sessionStorage) e navegou para '/'. */
export default function useOpenOsDetailsFromNav(openDetails) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname !== '/' || typeof openDetails !== 'function') return;
    const os = sessionStorage.getItem(OPEN_OS_DETAILS_KEY);
    if (!os) return;
    sessionStorage.removeItem(OPEN_OS_DETAILS_KEY);
    openDetails(os);
  }, [pathname, openDetails]);
}
